import React from 'react';
import { Input, Select, Spin, Button } from 'antd';
import clsx from 'clsx';

const { Option } = Select;

function CreateProjectDrawer({
  isOpen,
  onClose,
  isSubmitting,
  formData,
  handleInputChange,
  handleSelectChange,
  handleSubmit,
}) {
  return (
    <>
      {/* Overlay */}
      <div
        className={clsx(
          'fixed inset-0 bg-black/30 z-40 transition-opacity duration-300',
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        )}
        onClick={onClose}
      ></div>

      {/* Drawer */}
      <div
        className={clsx(
          'fixed top-0 right-0 w-[400px] h-full bg-white shadow-xl z-50 flex flex-col transform transition-transform duration-300',
          isOpen ? 'translate-x-0' : 'translate-x-full'
        )}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-5 border-b">
          <h2 className="text-xl font-semibold">Create Project</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-red-500 text-2xl leading-none focus:outline-none"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 p-6 overflow-y-auto relative">
          {isSubmitting && (
            <div className="absolute inset-0 bg-white/60 flex items-center justify-center z-10">
              <Spin size="large" />
            </div>
          )}

          <div className="flex flex-col gap-5">
            {/* Form Fields */}
            <div>
              <label className="text-sm font-medium mb-1 block">Project Name</label>
              <Input
                name="projectName"
                value={formData.projectName}
                onChange={handleInputChange}
                disabled={isSubmitting}
                className="w-full !border-gray-300 hover:!border-orange-500 focus:!border-orange-500"
                style={{
                  boxShadow: 'none',
                  transition: 'all 0.2s',
                }}
              />

            </div>

            <div>
              <label className="text-sm font-medium mb-1 block">Country</label>
              <Select
                name="country"
                value={formData.country}
                onChange={(value) => handleSelectChange('country', value)}
                disabled={isSubmitting}
                className="custom-orange-select w-full"
                style={{
                  boxShadow: 'none',
                  transition: 'all 0.2s',
                }}
                placeholder="Select a country"
              >
                <Option value="India">India</Option>
                <Option value="Botswana">Botswana</Option>
                <Option value="Dubai">Dubai</Option>
                <Option value="Kenya">Kenya</Option>
                <Option value="Tanzania">Tanzania</Option>
                {/* <Option value="UAE">UAE</Option> */}
              </Select>
            </div>

            <div>
              <label className="text-sm font-medium mb-1 block">Project Capacity</label>
              <Input
                name="projectCapacity"
                type="number"
                value={formData.projectCapacity}
                onChange={handleInputChange}
                disabled={isSubmitting}
                className="w-full !border-gray-300 hover:!border-orange-500 focus:!border-orange-500"
                style={{
                  boxShadow: 'none',
                  transition: 'all 0.2s',
                }}
              />
            </div>

            <div>
              <label className="text-sm font-medium mb-1 block">Capacity Unit</label>
              <Select
                value={formData.capacityUnit}
                onChange={(value) => handleSelectChange('capacityUnit', value)}
                disabled={isSubmitting}
                className="custom-orange-select w-full"
              >
                <Option value="kWp">kWp</Option>
                <Option value="MWp">MWp</Option>
              </Select>
            </div>

            <div>
              <label className="text-sm font-medium mb-1 block">Project Type</label>
              <Select
                value={formData.projectType}
                onChange={(value) => handleSelectChange('projectType', value)}
                disabled={isSubmitting}
                className=" custom-orange-select w-full"
              >
                <Option value="groundmount">Ground Mount</Option>
                <Option value="rooftop">Roof Top</Option>
              </Select>
            </div>

            <div>
              <label className="text-sm font-medium mb-1 block">Start Date</label>
              <Input
                className="w-full !border-gray-300 hover:!border-orange-500 focus:!border-orange-500"
                style={{
                  boxShadow: 'none',
                  transition: 'all 0.2s',
                }}
                name="projectStartDate"
                type="date"
                value={formData.projectStartDate}
                onChange={handleInputChange}
                disabled={isSubmitting}
              />
            </div>
          </div>
        </div>

        {/* Bottom Submit Button */}
        <div className="p-4">
          <Button
            className="w-full !bg-[#0D2B52] hover:!bg-[#173E73] !text-white text-base h-10 rounded rounded-[8px]"
            block
            onClick={handleSubmit}
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Create Project'}
          </Button>
        </div>
      </div>
    </>
  );
}

export default CreateProjectDrawer;
